//import React from 'react';
//import PropTypes from 'prop-types';

import { createUseStyles, useTheme } from 'react-jss';

const palette = {
  light: {
    font: {
      family: 'inherit',
      size: 14
    },

    colors: {
      basic: {
        value: '#fff',
        contrast: '#454545',
        border: '#c0c0c0'
      },

      primary: {
        value: '#472795',
        contrast: '#fff',
        border: '#2e1a65'
      },

      secondary: {
        value: '#f6f5ff',
        border: '#7e7cef'
      },

      tertiary: {
        value: '#6c757d',
        contrast: '#fff',
        border: '#454545'
      },

      quaternary: {
        value: '#454545',
        contrast: '#fff',
        border: '#000'
      },

      // special

      danger: {
        value: '#c20000',
        contrast: '#fff',
        border: '#8f0000'
      },

      warning: {
        value: '#ff9800',
        contrast: '#fff',
        border: '#e68a00'
      },

      info: {
        value: '#2196f3',
        contrast: '#fff',
        border: '#0a6fc2'
      },

      success: {
        value: '#4caf50',
        contrast: '#fff',
        border: '#3d8a3f'
      },

      hint: {
        value: '#c0c0c0',
        contrast: '#818181',
        border: '#818181'
      },

      hover: {
        value: '#f5f5f5'
      },

      disabled: {
        value: '#818181',
        contrast: '#d6d6d6',
        border: '#454545'
      }
    },

    border: {
      style: 'solid',
      width: 1,
      radius: 5
    },

    shadow: {
      color: 'rgba(0,0,0,0.05)',
      x: 0,
      y: 0,
      blur: 0,
      spread: 0
    },

    indent: 15,

    // components

    text: {},

    divider: {},

    card: {
      border: {
        radius: 20
      },
      shadow: {
        y: 4,
        blur: 25
      }
    },

    button: {},

    buttonGroup: {
      colors: {
        basic: {
          value: '#e8e8e8'
        }
      }
    },

    checkbox: {},

    textInput: {},

    tooltip: {
      shadow: {
        y: 4,
        blur: 25
      }
    }
  }
};

export default palette;

export { createUseStyles, useTheme };

export const createUseColoredStyles = (callback) =>
  Object.keys(palette.light.colors).reduce(
    (result, color, index) => (
      (result[color] = createUseStyles((theme) =>
        callback(theme, color, index, result)
      )),
      result
    ),
    {}
  );
